<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="users"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    import axios from 'axios';
    /**
     * Allows the selection of a user ID by choosing its name or code from
     * a selection downloaded from the API on creation
     */
    export default {
        name: 'ies-adminUserKey',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                users: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getHotels();
        },
        methods: {
            getHotels:function(){
                axios.get('/api/admin-users')
                .then(function(response){
                    var users = [];
                    response.data.forEach(function(record){
                        users.push({ text: '(' + record.departmentName + ') ' + record.first_name + ' ' + record.surname, value: record.user_key });
                    });
                    this.users = users;
                }.bind(this));
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
